// import { StreamVideoClient,StreamVideo,StreamCall, LivestreamLayout} from "@stream-io/video-react-sdk";
import { useCallback, useEffect, useReducer, useState } from 'react';
import Comments from '../components/Comments';
import CommentInput from '../components/CommentInput';
import { HbrCancel,HbrFlagReport, HbrLiveCam} from "./Mycustomsvgicons";
import { get, ref, set } from 'firebase/database';
import { realTimeDB } from '../firebase';
import { Link, useLocation } from 'react-router-dom';
import { actionConsts, reducer } from './StateManager';
import { CustomAlertDialog } from './CustomAlertDialog';
import { format } from 'date-fns';
import LiveCommentCount from './LiveCommentsCount';
import ShareComponent from './ShareComponent';
import ReactPlayer from 'react-player';
import UseLayout from './useLayout';
import { TextShortenerConfig } from './GeneralClasses';

const ViewAsHls =() => {
    const [showChat,setShowChat]=useState(true);
    const [liveStarted,setLiveStarted]=useState(false);
    const [state,dispatch]=useReducer(reducer,{alertMessage: "No Live stream in session.\nPrograms available to Broadcast: Sunday Bible studies 3:30pm\nAll other Horemow conferences and programs of the movement", showAlert: false});
    const [linkFromDB,setLinkFroMdb]=useState("");
   const [docIDstofetch,setDocIDquery]=useState("");
   const [hlsUrl,setHlsUrl]=useState("");
   const [playing,setIsPlaying]=useState(false);
   const [buffering,setBuffering]=useState(false);
   const {width} = UseLayout();
   const location = useLocation();
   const queryParams = new URLSearchParams(location.search);    
   const watch = queryParams.get("watch");

   const handleBuffering=()=>{
    setBuffering(true);
    };

    const handleBufferEnd=()=>{
        setBuffering(false);
    };

    const handleCloseAlert=()=>{
        dispatch({type: actionConsts.SHOWALERT, payload: true});
      };


      const handleMakeCommentsVisible=useCallback((data)=>{
        if (data === true) {
            setShowChat(true);
            setDocIDquery("");
        }
      },[]);

      const handleHideComments=useCallback(()=>{
        setShowChat(false);
        sessionStorage.setItem("docID",format(new Date(),"yyyyMMddHHmmss"));
        setDocIDquery(sessionStorage.getItem("docID"));
      },[]);

    useEffect(()=>{
        async function fetchUrl() {
            const viewDate = format(new Date(), "yyyy-MM-dd");
            const alphabets = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
            const randomUUid = `hbrUser${Math.floor(Math.random() * 10000)}${alphabets.charAt(Math.floor(Math.random() * alphabets.length))}`
          
            const livebooleanvalue = await get(ref(realTimeDB,"Banner/hbrLiveSettings/live"));
                setLiveStarted(livebooleanvalue.val());
                sessionStorage.setItem("docID",format(new Date(),"yyyyMMddHHmmss"));
                setDocIDquery(sessionStorage.getItem("docID"));
                const hlsUrlSnapshot = await get(ref(realTimeDB,"Banner/hbrLiveSettings/hlsUrl"));
                setHlsUrl(hlsUrlSnapshot.val());
                const linkTocopySnapshot = await get(ref(realTimeDB,"Banner/hbrLiveSettings/shareLink/link"));
                setLinkFroMdb(linkTocopySnapshot.val());
                const viewerID = localStorage.getItem("bloggerid");
                const viewerName = localStorage.getItem("userName");
                set(ref(realTimeDB,`Views${viewDate}/${viewerID ? viewerID : randomUUid}`),viewerName ? viewerName: randomUUid);
            
        };
        fetchUrl();
    },[]);

 


    return (  
 
    <div className='livestreamviewlayout'>
             {!liveStarted && !state.showAlert &&
                  <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={handleCloseAlert}/>
            }

        <div className="livestreamviewcontent" style={{width:"100%",height:"100vh"}}>

            <div className={`livevideoplayer ${showChat ? 'resize':'full'}`} style={{backgroundColor:"black",position:"relative"}}>

                {liveStarted && 
                    <div style={{display:"flex",gap:"5px",height:"auto",alignItems:"center",width:"100%",caretColor:"transparent"}}>
                        <div className='flex-row2'
                         style={{
                             padding:"3px",
                             gap:"3px",
                             width:"fit-content",
                             border:"none",
                             backgroundColor:"red",
                             color:"white",
                             fontWeight:"bold",
                             fontSize:"0.8em",
                             borderRadius:"10px",
                             animation:"fade180 2s linear infinite"}}>
                             <h4 style={{color:"white"}}>Live </h4>
                             <HbrLiveCam width="1em" height="1em" fillColour="#FFFFFF"/>
                         </div>

                        <div style={{padding:"5px"}}>
                            {/* <pre style={{color:"white",fontWeight:"bold"}}>{`${watch} ${marqueeText}`}</pre> */}
                            {width <= 600 ? <TextShortenerConfig fullText={watch} words={5} /> : <TextShortenerConfig fullText={watch} words={10} />}
                            
                        </div>

                    </div>
                }

                    {liveStarted &&
                    <div style={{width:"100%",height:"100%"}}
                         onClick={()=>setIsPlaying(prev => !prev)} onContextMenu={e => e.preventDefault()}>
                    
                         <ReactPlayer 
                             url={hlsUrl}
                             playing={playing}
                             onBuffer={handleBuffering}
                             onBufferEnd={handleBufferEnd}
                             width={"100%"}
                             height={"100%"}
                             controls
                         />
                     </div>
                    } 

                    {buffering && 
                        <div style={{
                            position:"absolute",
                            top:"50%",
                            left:"45%",
                            width:"50px",
                            height:"50px",
                            border: "5px solid #00000080",
                            borderBottom: "5px solid white",
                            borderTop: "5px solid white",
                            borderRadius: "50%",
                            animation: "spin2 2s linear infinite",
                            }}>
                        </div>
                    }
                    
                    {!showChat && 
                        <LiveCommentCount showChat={showChat} docIDstofetch={docIDstofetch} handleShowComment={handleMakeCommentsVisible} />
                    }
            
            </div>

           

            <div className={`livestreamcommentdiv flex-column1 ${showChat ? 'show':'hide'}`}>
                    <div className="livestreamcommentstop flex-spacebetween" style={{width:"100%",backgroundColor:"white"}}>

                        <ShareComponent linkFromDB={`${linkFromDB}hbrlivev2?watch=`} watch={watch}/>
                      
                        <Link to={"/contact"} style={{textDecoration:"none",color:"red",backgroundColor:"whitesmoke"}}>
                             report <HbrFlagReport width="1.6em" height="1.6em" fillColour="black"/>
                        </Link>
                          
                        <HbrCancel width="1.7em" height="1.7em" fillColour="#000000" handleClick={handleHideComments}/>
                        
                    </div>
                    <Comments/>
                    <CommentInput/>
            </div>
        </div>

    </div>
    
    );
}
export default ViewAsHls;